import type { Order } from '../types';

export interface OrderDateGroup {
  key: string;
  label: string;
  orders: Order[];
}

const DAY_LABEL_FORMAT = new Intl.DateTimeFormat('ru-RU', { day: 'numeric', month: 'long', weekday: 'short' });

function startOfDay(d: Date): Date {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

function dayLabel(day: Date, today: Date): string {
  const diffDays = Math.round((day.getTime() - today.getTime()) / 86400000);
  if (diffDays === 0) return 'Сегодня';
  if (diffDays === 1) return 'Завтра';
  if (diffDays === -1) return 'Вчера';
  const formatted = DAY_LABEL_FORMAT.format(day);
  return diffDays < 0 ? `${formatted} — просрочено` : formatted;
}

// Группирует наряды по дню наряда (scheduledAt) — без даты идут отдельной группой первыми
// (это то, что диспетчеру/технику надо разобрать в первую очередь), дальше по возрастанию даты
export function groupOrdersByDate(orders: Order[]): OrderDateGroup[] {
  const withoutDate = orders.filter((o) => !o.scheduledAt);
  const buckets = new Map<string, Order[]>();

  for (const o of orders) {
    if (!o.scheduledAt) continue;
    const key = startOfDay(new Date(o.scheduledAt)).toISOString();
    if (!buckets.has(key)) buckets.set(key, []);
    buckets.get(key)!.push(o);
  }
  for (const list of buckets.values()) {
    list.sort((a, b) => new Date(a.scheduledAt!).getTime() - new Date(b.scheduledAt!).getTime());
  }

  const today = startOfDay(new Date());
  const groups: OrderDateGroup[] = [];
  if (withoutDate.length > 0) {
    groups.push({ key: 'none', label: 'Без даты', orders: withoutDate });
  }
  for (const key of Array.from(buckets.keys()).sort()) {
    groups.push({ key, label: dayLabel(new Date(key), today), orders: buckets.get(key)! });
  }
  return groups;
}
